import { http } from '@/core/api/';
import EduEspCode from '@/utils/constants/eduEspCode';
import documentCategory from '@/utils/constants/documentCategory.js';

const formsBaseURL = 'api/forms';

export default {
  getCategories() {
    return http.get(
      `api/code/getEduEspCodes?codeType=${EduEspCode.FrmCategory}`
    );
  },
  getForms(filter) {
    return http.get(`${formsBaseURL}`, {
      params: {
        categoryCode: filter.categoryCode,
        searchField: filter.searchField,
        isActive: filter.isActive,
        pageIndex: filter.currentPage,
        pageSize: filter.count,
      },
    });
  },
  getFormData(id) {
    return http.get(`${formsBaseURL}/${id}`);
  },
  create(formData) {
    return http.post(`${formsBaseURL}/create`, formData);
  },
  update(formData) {
    return http.put(`${formsBaseURL}/update`, formData);
  },
  async downloadForm(form) {
    let id = null;
    if (form.documentId) {
      id = form.documentId;
    } else if (form.attachmentId) {
      id = form.attachmentId;
    }

    return http.get(
      `api/documents/documentbycategory/${id}/${documentCategory.ThrpyReferral}`
    );
  },
  deleteForm(id) {
    return http.put(`${formsBaseURL}/delete/${id}`);
  },
};
